export class ReimputarMovimiento{
    movimientoId: string;
    fecha: string;
    cierreTurnoId: string;
}